module.exports = __webpack_public_path__ + "resources/img/img_iTracerAF1_m_en.87b43fac48cd6ead2c8c5631328b7e8d.png";